/** @file Rotate tool registration: title and activation chord E (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Turns the selected bones (setup values or keys). */
export const tool: ToolDef = { id: 'rotate', title: 'tools.rotate.title', bindings: [{ id: 'tool.rotate', keys: 'KeyE', context: 'viewport' }] };
